import { useEffect, useState } from 'react';
import axios from 'axios';

const apiUrl = 'https://elcobradorleague.com/api';

export const useHonor = () => {
  const [honorData, setHonorData] = useState([]);

  useEffect(() => {
    const controller = new AbortController();

    axios.get(
      `${apiUrl}/api.php?endpoint=honorsummary`,
      {
        headers: {
          'X-API-TOKEN': process.env.REACT_APP_API_TOKEN
        },
        signal: controller.signal
      }
    )
    .then(res => {
      setHonorData(Array.isArray(res.data) ? res.data : []);
    })
    .catch(err => {
      if (err.name !== 'CanceledError') {
        setHonorData([]);
      }
    });

    return () => controller.abort();
  }, []);

  return { honorData };
};
